/**
 * Created by slava on 9/8/17
 */

const FieldBoosterView = cc.Node.extend({
    ctor: function (booster) {
        this._super();

        this.booster = booster;

        this.setAnchorPoint(0.5, 0.5);

        this.createIcon();

        booster.onStopListener = this.createListener(this.stop.bind(this));
        booster.onActivateListener = this.createListener(this.showActivated.bind(this));
        booster.onDeactivateListener = this.createListener(this.showDeactivated.bind(this));
        booster.onHurtCellsListener = this.createListener(this.onHurtCellsAnimation.bind(this));
        booster.onGetView = this.createListener(() => this);

        const styles = cleverapps.styles.FieldBoosterView;

        if (styles.background) {
            this.bg = this.createBackground(bundles.game.frames.booster_icon_bg_png);

            this.bgOn = this.createBackground(bundles.game.frames.booster_icon_bg_on_png);
            this.bgOn.setVisible(false);
        }

        if (this.booster.isDisabled() && styles.locked) {
            this.createLockIcon();
        }

        if (booster.isDisabled() && styles.hideWhenDisabled) {
            this.setVisible(false);
        }

        this.amount = new BoosterAmountView(booster);
        this.amount.setAlignment(this.width + styles.amount.x, styles.amount.y);
        this.addChild(this.amount);

        this.onResize();

        this.createPrice();

        this.onChangeAmount();

        if (booster.isDisabled()) {
            this.disable();
        } else {
            this.enable();
        }
    },

    createPrice: function () {
        const styles = cleverapps.styles.FieldBoosterView.price;

        const content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize2(styles.content.width, styles.content.height);

        const price = this.price = new TextWithIcon(`$$${this.booster.getPrice().amount}`, {
            font: cleverapps.styles.FONTS.FIELD_BOOSTER
        });

        const ads = this.ads = new TextWithIcon("## x1", {
            font: cleverapps.styles.FONTS.FIELD_BOOSTER
        });

        const free = this.free = new TextWithIcon(Messages.get("BoosterFree"), {
            font: cleverapps.styles.FONTS.FIELD_BOOSTER
        });

        [price, ads, free].forEach((item) => {
            item.fitTo(styles.width * 0.9);
            item.setPosition(content.width / 2, content.height / 2);

            content.addChild(item);
        });

        const priceButton = this.priceButton = new cleverapps.UI.Button({
            content,
            width: styles.width,
            height: styles.height,
            type: styles.type,
            keepRadius: true,
            onClicked: function () {
                Game.currentGame.boosters.onTouchBegan(this.booster);
            }.bind(this)
        });

        this.addChild(priceButton);
        priceButton.setAlignment(styles);
    },

    onResize: function () {
        const styles = cleverapps.styles.FieldBoosterView;

        if (styles.scales) {
            this.setScale(styles.scales[cleverapps.resolution.mode]);
            this.baseScale = styles.scales[cleverapps.resolution.mode];
        }
    },

    stop: function () {
        if (this.touchListener) {
            this.touchListener.remove();
            this.touchListener = undefined;
        }
    },

    enable: function () {
        cleverapps.UI.applyHover(this);

        this.touchListener = cleverapps.UI.onDrag(this, {
            instantDrag: true,
            onOuterTouch: this.onOuterTouch.bind(this),
            onDragStart: this.onTouchBegan.bind(this),
            onDragMoveNotThrottled: this.onTouchMoved.bind(this),
            onMouseMove: this.onMouseMove.bind(this),
            onDragEnd: this.onTouchEnded.bind(this)
        });

        this.booster.on("changeAmount", this.createListener(this.onChangeAmount.bind(this)), this);
        this.booster.on("freePrice", this.createListener(this.onChangeAmount.bind(this)), this);
        this.booster.on("regularPrice", this.createListener(this.onChangeAmount.bind(this)), this);
        cleverapps.adsLimits.on("update", this.onChangeAmount.bind(this), this);
        cleverapps.user.on("changeHard", this.onChangeAmount.bind(this), this);
    },

    disable: function () {
        this.amount.setVisible(false);
        this.priceButton.setVisible(false);
        this.icon.setVisible(false);
    },

    onChangeAmount: function () {
        const boosterState = this.booster.getState();
        const isFreePrice = this.booster.isFreePrice;

        if (boosterState === BaseBooster.AMOUNT_STATE) {
            this.amount.setAmount(this.booster.getAmount());
        }

        this.amount.setVisible(!isFreePrice && boosterState === BaseBooster.AMOUNT_STATE);
        this.priceButton.setVisible(isFreePrice || boosterState !== BaseBooster.AMOUNT_STATE);
        this.price.setVisible(!isFreePrice && boosterState === BaseBooster.PRICE_STATE);
        this.ads.setVisible(!isFreePrice && boosterState === BaseBooster.ADS_STATE);
        this.free.setVisible(isFreePrice);
    },

    createLockIcon: function () {
        const styles = cleverapps.styles.FieldBoosterView;

        const lockIcon = new cc.Sprite(bundles.game.frames.locked_png);
        this.bg.addChild(lockIcon);

        lockIcon.setAlignment(styles.locked.x, styles.locked.y);
    },

    createBackground: function (image) {
        const styles = cleverapps.styles.FieldBoosterView;

        let bg;
        const bgStyles = styles.background[cleverapps.resolution.mode];
        if (bgStyles && bgStyles.scale9) {
            bg = cleverapps.UI.createScale9Sprite(image, bgStyles.scale9);
        } else {
            bg = new cc.Sprite(bundles.game.frames.booster_icon_bg_png);
        }
        bg.setLocalZOrder(-1);
        bg.setAlignment(this.width / 2 + styles.bgOffset.x, this.height / 2 + styles.bgOffset.y);

        bg.onResize = function () {
            const bgStyles = styles.background[cleverapps.resolution.mode];
            if (bgStyles && bgStyles.scale9) {
                bg.setContentSize(bgStyles.width, bgStyles.height);
            }
        };

        bg.onResize();

        this.addChild(bg);

        return bg;
    },

    createIcon: function () {
        this.icon = new cc.Sprite(this.booster.icon);
        this.setContentSize2(this.icon.width, this.icon.height);
        this.icon.setAlignment(this.width / 2, this.height / 2);
        this.addChild(this.icon);
    },

    showActivated: function () {
        this.icon.setSpriteFrame(this.booster.icon_active);
        this.setBackground(true);
    },

    showDeactivated: function () {
        this.icon.setSpriteFrame(this.booster.icon);
        this.setBackground(false);
    },

    onTouchBegan: function () {
        if (cleverapps.tutorial.isActive() && Game.currentGame.boosters.active) {
            return;
        }

        cleverapps.userStatus.reportUserAction();

        return Game.currentGame.boosters.onTouchBegan(this.booster);
    },

    onOuterTouch: function (touch) {
        const targetCell = Game.currentGame.field.onGetView().getTouchedCell(touch);

        return Game.currentGame.boosters.onTouchOut(this.booster, targetCell);
    },

    onTouchMoved: function (touch) {
        Game.currentGame.boosters.onTouchMoved(touch);
        const listener = Game.currentGame.boosters.onPointerMoveListener;
        if (listener && !this.containsTouch(touch)) {
            listener(touch);
        }
    },

    onMouseMove: function (event) {
        const listener = Game.currentGame.boosters.onPointerMoveListener;
        if (listener) {
            listener(event);
        }
    },

    onTouchEnded: function (touch) {
        cleverapps.userStatus.reportUserAction();

        if (this.containsTouch(touch)) {
            return;
        }

        const targetCell = Game.currentGame.field.onGetView().getTouchedCell(touch);
        Game.currentGame.boosters.onTouchEnded(targetCell);
    },

    containsTouch: function (touch) {
        const point = this.convertTouchToNodeSpace(touch);
        return cc.rectContainsPoint(cc.rect(0, 0, this.width, this.height), point);
    },

    onHurtCellsAnimation: function () {

    },

    setBackground: function (isOn) {
        if (cleverapps.styles.FieldBoosterView.background) {
            this.bg.visible = !isOn;
            this.bgOn.visible = isOn;
        }
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    FIELD_BOOSTER: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.FieldBoosterView = {
    zoomScale: 1.05,

    amount: {
        x: -16,
        y: 10
    },

    price: {
        width: 130,
        height: 55,
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: -25 },
        content: {
            width: 110,
            height: 35
        },
        type: cleverapps.styles.UI.Button.Images.small_button_green
    },

    bgOffset: {
        x: 0,
        y: 0
    },

    locked: {
        x: { align: "center" },
        y: { align: "center" }
    }
};
